module.exports = __webpack_public_path__ + "static/media/ico-floating-create.429bf257.svg";